import { toContentHref } from '@/utils/content-ref';
import type { FullDetailCalendarProjection } from '@vivport/backend/types';
import type { CSSProperties } from 'react';
import { AppLink } from '@/components/ui/app-link';

interface CalendarEventCardProps {
  event: FullDetailCalendarProjection;
  style: CSSProperties;
  segmentStart: Date;
  segmentEnd: Date;
}

function formatTimeLabel(start: Date, end: Date, isAllDay: boolean): string {
  if (isAllDay) {
    return 'All day';
  }
  const formatter = new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });
  return `${formatter.format(start)} - ${formatter.format(end)}`;
}

export function CalendarEventCard({ event, style, segmentStart, segmentEnd }: CalendarEventCardProps) {
  const title = event.title.trim().length > 0 ? event.title : 'Untitled event';
  const timeLabel = formatTimeLabel(segmentStart, segmentEnd, event.isAllDay);

  return (
    <AppLink
      to={toContentHref(String(event.eventId))}
      style={style}
      className="absolute z-20 overflow-hidden rounded-md border border-primary/30 bg-primary/10 p-2 text-xs text-foreground shadow-sm hover:bg-primary/15"
      title={`${title} (${timeLabel})`}
    >
      <p className="truncate font-medium">{title}</p>
      <p className="truncate text-muted-foreground">{timeLabel}</p>
    </AppLink>
  );
}
